import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { NgbCalendar, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-datepicker-input',
  templateUrl: './datepicker-input.component.html',
  styleUrls: ['./datepicker-input.component.scss']
})
export class DatepickerInputComponent {
  @Input() label: string;
  @Input() labelClass: string = '';
  @Input() placeholder: string;
  @Input() control: FormControl<any> | any;
  @Output() dropdownShow = new EventEmitter<boolean>();
  @Input() minDate: any;
  @Input() maxDate: any;

  constructor(private calendar: NgbCalendar) { }

  toggle(calendar: any) {
    calendar.toggle();
    this.dropdownShow.emit(calendar.isOpen());
  }

  getFormattedDate(date: NgbDateStruct): string {
    if (!date) return '';
    const jsDate = new Date(date.year, date.month - 1, date.day);
    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];

    const day = days[jsDate.getDay()];
    const month = months[jsDate.getMonth()];
    const year = jsDate.getFullYear();

    // Formatted date string
    return `${day}, ${month} ${jsDate.getDate()}`;
  }
}
